import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles(theme => ({
  exitButton: {
    "backgroundColor": theme.palette.error.main,
    "color": theme.palette.getContrastText(theme.palette.error.main),
    "&:hover": {
      backgroundColor: theme.palette.error.light,
    },
  },
}));

export default useStyle;
